export default "__VITE_ASSET__DpOuHwoV__"